import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import ReactPaginate from 'react-paginate';
import { userAction } from '../../actions/userAction';
import { DABInlineLoading, DABTextBox } from '../../components/dab';
import moment from 'moment';

interface IUserProps {
	dispatch: Dispatch<any>;
	userData: any;
	showSearch: any;
	title: any;
}

const CommunityUser: React.SFC<IUserProps> = ({
	dispatch, userData, showSearch, title }) => {
	let dateFormat = "MM-DD-YYYY";

	const initialInputValue = {
		pageNumber: 1,
		pageSize: 5,
		sortColumn: "DATE",
		roleCode: [],
		sortDirection: "desc",
		searchString: ""
	};

	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [pageList, setPageList] = useState([1]);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [isFilter, setIsFilter] = useState(false);


	const handleFilter = () => {
		setCurrentPageNo(0);
		userData.isFilterAndTotalCountDataLoaded = true;
		userData.isListSuccess = true;
		setFilterInput({
			...filterInput,
			pageNumber: 1,
			searchString: searchText
		});
		setShowModal(true);
		if (searchText != "")
		setIsFilter(true)
	};

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = ""
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else if (input.sortDirection === "asc") {
				sDir = "desc";
			}
		}
		else {
			sDir = "desc";
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		});
		setIsFilter(!(sDir === "desc" && sortColumn === "DATE") || filterInput.searchString != "")
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon icon={faChevronUp} />
			}
			else if (input.sortDirection === "asc") {
				return <FontAwesomeIcon icon={faChevronDown} />
			}
		}
	}

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div'onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	const handlePageClick = (data) => {
		setFilterInput({
			...filterInput,
			pageNumber: data.selected + 1,
		});
		setCurrentPageNo(data.selected);
	};

	const handleClearFilter = () => {
		if (searchText != "") setSearchText("");
		setIsFilter(false);
		setCurrentPageNo(0);
		setFilterInput(initialInputValue);
	}

	const handleDetailNavigation = (val : number) => {
			sessionStorage.setItem("userId", JSON.stringify(val));
			sessionStorage.setItem("resFilter", JSON.stringify(filterInput))
	}

	React.useEffect(() => {
		dispatch(userAction.userGetByFilter(filterInput));
		setShowModal(true)
		var userId = sessionStorage.getItem("userId");
		var filterVal = sessionStorage.getItem("resFilter");
		if (userId != null && filterVal != null) {
			var filterObj = JSON.parse(filterVal)
			if (!(filterObj.sortDirection === "desc" && filterObj.sortColumn === "DATE") || filterObj.searchString != "") setIsFilter(true)
				setFilterInput(filterObj)
				setCurrentPageNo(filterObj.pageNumber - 1);
				setSearchText(filterObj.searchString)
				sessionStorage.removeItem("userId");
				sessionStorage.removeItem("resFilter");
		}

	}, [filterInput]);

	const handleInputChange = (event) => {
		setSearchText(event.target.value);
	};

	if (userData && userData.isListSuccess) {
		userData.isListSuccess = false;
		setShowModal(false);
		var total: number = userData.totalCount;
		var pList: number[] = [];
		if (total > 5) {
			for (var i = 1; i <= (total / 5); i++) {
				pList.push(i);
			}
			if ((total % 5) > 0) {
				pList.push((parseInt((total / 5).toString()) + 1));
			}
		}
		else {
			pList.push(1);
		}
		setPageList(pList);
	}

	return (
		<div className="community-user">
			<h5>
				<span data-testid="communityUsersTitle">{title}</span>
			</h5>
			{showSearch && <>

				<Row className="card-box search">
					<Col lg="4" data-testid="searchContainer">
						<DABTextBox type={!isFilter ?"search" : "text"} id="searchText" isRequired={false} 
							onChange={(event) => { handleInputChange(event) }}
							value={searchText} />
					</Col>
					<Col lg="3" data-testid="searchSubmitContainer">
						<Button id="submit" style={{ float: "left" }} color="primary" onClick={() => { handleFilter() }} className="search-button">Search</Button>
						{isFilter && <Button id="submit" style={{ float: "right" }} color="primary" onClick={() => { handleClearFilter() }} className="clear-filter-button">Clear</Button>}
					</Col>
				</Row>
			</>
			}

			<table className="table table-bordered text-center communityusersdiv" data-testid="communityUsersTable">
				<thead data-testid="communityUserHead">
					<tr>
						<th key={title + "Name"} data-testid="name" style={{ width: "25%" }} scope="col">{handleGetSortColumn("Name", "NAME")}</th>
						<th key={title + "EMAIL"} data-testid="email" style={{ width: "25%" }} scope="col">{handleGetSortColumn("Email", "EMAIL")}</th>
						<th key={title + "DATE"} data-testid="date" style={{ width: "15%" }} scope="col">{handleGetSortColumn("Registered", "DATE")}</th>
						<th key={title + "Channels"} data-testid="channel" style={{ width: "35%" }} scope="col">Channels</th>
					</tr>
				</thead>
				<tbody>
					{!showModal && userData && userData.items.length === 0 ?
						<tr>
							<td colSpan={4} style={{ verticalAlign: "middle" }}>
								No Records...
							</td>
						</tr>
						:
						!showModal && userData && userData.items.map((data: any) =>
							<tr data-testid="userRow" key={title + data.userId}>
								<td data-testid="userName" key={title + data.name}><a href={"/dashboard?id=" + data.userId} onClick={() =>handleDetailNavigation(data.userId)}>{data.name}</a></td>
							<td data-testid="userEmail" key={title + data.userName}>{data.email}</td>
							<td data-testid="userRegistered" key={title + data.createdAtUtc.toString()}>{moment(data.createdAtUtc).format(dateFormat)}</td>
							<td data-testid="userChannel" key={title + data.channels}>{data.channels}</td>
						</tr>
					)}
					{showModal &&
						<tr>
							<td colSpan={4} style={{ verticalAlign: "middle" }}>
								<DABInlineLoading />
							</td>
						</tr>
					}

				</tbody>
			</table>
			<Row>
				<Col lg="6">
				</Col>
				<Col lg="6">
					<div className="pagination" style={{ float: 'right' }}>
						<ReactPaginate
							previousLabel={'Previous'}
							nextLabel={'Next'}
							breakLabel={'...'}
							pageCount={pageList.length}
							marginPagesDisplayed={2}
							pageRangeDisplayed={5}
							onPageChange={handlePageClick}
							forcePage={currentPageNo}
							containerClassName={'pagination'}
							pageClassName={"page-item"}
							previousClassName={"page-item"}
							breakClassName={"page-item"}
							breakLinkClassName={"page-link"}
							nextClassName={"page-item"}
							pageLinkClassName={"page-link"}
							previousLinkClassName={"page-link"}
							nextLinkClassName={"page-link"}
							activeClassName={'active'}
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { userData } = state;
	return {
		userData
	};
};

export default connect(mapStateToProps)(CommunityUser);


